import { Typography } from 'antd';
import React from 'react';
import {
  FormConfigProps,
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { DynamicFormField } from '../DynamicFormField';

export const block2config: Record<string, FormConfigProps> = {
  simplifiedTasks: {
    label: 'užduotys supaprastinamos, siaurinamos, konkretinamos',
    value: 'simplifiedTasks',
    children: {
      simplifiedTasks75: {
        label: '75%',
        value: 'simplifiedTasks75',
        paddingLeft: 24,
      },
      simplifiedTasks50: {
        label: '50%',
        value: 'simplifiedTasks50',
        paddingLeft: 24,
      },
      simplifiedTasks25: {
        label: '25%',
        value: 'simplifiedTasks25',
        paddingLeft: 24,
      },
    },
  },
  prepareClearVividTasks: {
    label: 'parenkamos / parengiamos vaizdžios užduotys',
    value: 'prepareClearVividTasks',
  },
  clearVividTasks: {
    label: 'parenkamos aiškios, suprantamos, vaizdžios užduotys',
    value: 'clearVividTasks',
  },
  interactiveTasks: {
    label: 'rengiamos interaktyvios užduotys',
    value: 'interactiveTasks',
  },
  replacedMadeEasier: {
    label: 'užduotys keičiamos kitomis, lengvesnėmis',
    value: 'replacedMadeEasier',
    children: {
      replacedMadeEasier75: {
        label: '75%',
        value: 'replacedMadeEasier75',
        paddingLeft: 24,
      },
      replacedMadeEasier50: {
        label: '50%',
        value: 'replacedMadeEasier50',
        paddingLeft: 24,
      },
      replacedMadeEasier25: {
        label: '25%',
        value: 'replacedMadeEasier25',
        paddingLeft: 24,
      },
    },
  },
  supportingExamples: {
    label:
      'atraminė medžiaga ir (ar) analogiškai atliktų užduočių pavyzdžiai pateikiami atskirame užduočių lape',
    value: 'supportingExamples',
  },
  openEndedResources: {
    label:
      'atviro tipo klausimuose pateikiamos nuorodos (puslapis, pastraipa ar kt.), kur ieškoti atsakymo',
    value: 'openEndedResources',
  },
  partOpenEndedToClosedEnded: {
    label: 'dalis atviro tipo klausimų keičiami į uždaro tipo klausimus',
    value: 'partOpenEndedToClosedEnded',
  },
  openEndedBeginings: {
    label: 'atviro tipo klausimuose pateikiama sakinio pradžia',
    value: 'openEndedBeginings',
  },
  largeWideFont: {
    label: 'užduotys parengiamos stambiu šriftu, plačiu intervalu',
    value: 'largeWideFont',
  },
  narratedTasks: {
    label:
      'užduotys įgarsinamos naudojantis specialiosiomis mokymo priemonėmis',
    value: 'narratedTasks',
  },
  studentInterestTasks: {
    label: 'užduotys parengiamos, atsižvelgiant į mokinio pomėgius',
    value: 'studentInterestTasks',
  },
  sequenceDiagramTasks: {
    label: 'užduotys papildomos atlikimo veiksmų sekos schemomis',
    value: 'sequenceDiagramTasks',
  },
  criticalPointsMarked: {
    label:
      'užduotyse pažymimos vietos, kuriose pateikiama svarbi informacija ar galima klaidos tikimybė',
    value: 'criticalPointsMarked',
  },
  otherTasks: {
    isInput: true,
    label: 'kita:',
    value: 'otherTasks',
  },
};

export const Block2 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 2 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Užduočių pritaikymas:
        </Typography.Title>
        <DynamicFormField
          formItemConfig={block2config}
          formPathParams={['subject', 'block2']}
          form={form}
        />
      </div>
    );
  },
);
